module.exports = __webpack_public_path__ + "static/sport/tag-regist.ea2c7ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport8/tag-regist.png
// module id = OFbL
// module chunks = 0